import type { MetricsReporter, Logger } from '@wix/thunderbolt-types'
import type { SiteAssetsMetricsReporter } from '@wix/metrics-reporter'

type RequestBody = BodyInit | XMLHttpRequestBodyInit | null | undefined

// This is the public API for the SSR isolate environment.
// This env is exposed by the isolated-renderer-loader and its bridges
export interface SSRIsolateEnvironment {
	bridgedSantaModuleFetcher: (
		fetchOptions: { fromUrl: string; targetPath: string },
		disableCache: boolean,
	) => Promise<string>
	fetchOOIComponent: (
		dependencies: Record<string, any>,
		url: string,
		entryInZip?: string,
	) => Promise<any>
	readFileSync: (filePath: string) => string
	normalizeBody: (body: RequestBody) => string | undefined
	compileBuilderComponent: (
		componentUrl: string,
		moduleSpecifier: string,
		builderPublicPackagesUrls: {
			esm: Record<string, string>
			umd: Record<string, string>
		},
		serverComponentsImports: Record<string, string>,
		shouldDisableBuilderWixComponents?: boolean
	) => Promise<void>
	// TextEncoder/TextDecoder bridge functions
	textCodec: {
		shouldUseBridge: (inputLength: number) => boolean
		encode: (str: string) => Uint8Array
		encodeInto: (str: string, buf: Uint8Array) => { read: number; written: number }
		decode: (buf: Uint8Array) => string
	}

	// Logging and metrics
	wixLog: (name: string) => Logger
	ssrContextualLogger: (name: string) => Logger
	metricsReporter: MetricsReporter
	siteAssetsMetricsReporter: SiteAssetsMetricsReporter

	// Global maps
	builderComponentModules: { [namedExport: string]: any }
	cachedModules: Map<string, any>

	// Script preloading function
	preloadScripts: Function

	// Main render function
	thunderboltRenderSite: Function
}

// This env is created by the isolated-renderer-loader
declare global {
	var __ssrIsolateEnv: SSRIsolateEnvironment
}

// This should be exposed by the isolated-renderer
export const ssrIsolateEnv = globalThis.__ssrIsolateEnv

export const isIsolatedEnvironment = '__ssrIsolateEnv' in globalThis
